"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M19,6.5c-2.45,0-4.44.76-4.9,1.79a1,1,0,0,1,.58.29l1.59,1.59A11.2,11.2,0,0,0,19,10.5c2.29,0,4.31-.63,5-1.29V8.75C24,7.49,21.77,6.5,19,6.5Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M16.88,10.82l.44.44a1,1,0,0,1,.23.34,1,1,0,0,1-.15,1,11.79,11.79,0,0,0,1.56.1c2.29,0,4.31-.63,5-1.29V9.83A10,10,0,0,1,19,11,12.24,12.24,0,0,1,16.88,10.82Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M17,13.09l-1.39,1.39A10.6,10.6,0,0,0,19,15c2.29,0,4.31-.63,5-1.29V12.08a10,10,0,0,1-5,1.17A12.26,12.26,0,0,1,17,13.09Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M15.19,14.87l-.55.55a1,1,0,0,1-.58.29c.46,1,2.45,1.79,4.9,1.79,2.8,0,5-1,5-2.25v-.92a10,10,0,0,1-5,1.17A11.05,11.05,0,0,1,15.19,14.87Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M5,10.5c2.29,0,4.31-.63,5-1.29V8.75C10,7.49,7.84,6.5,5,6.5s-5,1-5,2.25C0,9.54,2.27,10.5,5,10.5Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M5,12.75c.33,0,.65,0,1,0A1,1,0,0,1,6.77,11H10V9.83A10,10,0,0,1,5,11c-2,0-4.07-.5-5-1.32V11C0,11.79,2.27,12.75,5,12.75Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M5,13.25c-2,0-4.07-.5-5-1.32v1.32C0,14,2.27,15,5,15c2.29,0,4.31-.63,5-1.29V13H7.32A13,13,0,0,1,5,13.25Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M0,14.18v1.07c0,1.26,2.2,2.25,5,2.25s5-1,5-2.25v-.92A10,10,0,0,1,5,15.5C3.05,15.5,1,15,0,14.18Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M14.61,14.61l.37-.37,1.29-1.29.42-.42.21-.21a.45.45,0,0,0,.1-.15.45.45,0,0,0,0-.34.44.44,0,0,0-.1-.14l-1.12-1.12-.86-.86-.7-.7A.44.44,0,0,0,14,8.88h-.08a.44.44,0,0,0-.32.13.45.45,0,0,0,0,.63L14,10l1.55,1.55H6.77a.45.45,0,0,0,0,.89h8.74l-.21.21-1.08,1.08-.63.63a.45.45,0,0,0,0,.63.44.44,0,0,0,.32.13H14a.44.44,0,0,0,.26-.13Z"
  })));
};

exports["default"] = _default;